import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { supabase } from '../lib/supabase'

// Must match the sessionStorage key in AcceptInvite.tsx. sessionStorage so
// the token drops on tab close and isn't replayable across tabs.
const INVITE_TOKEN_STORAGE_KEY = 'pending_invite_token'

export default function AuthCallback() {
  const navigate = useNavigate()
  const { user, loading } = useAuth()

  useEffect(() => {
    if (loading) return
    if (!user) {
      navigate('/sign-in', { replace: true })
      return
    }

    // If we got here via the AcceptInvite flow, finish the invite + route
    // to Mom Mode. Otherwise (normal owner sign-in) route to Home.
    const token = window.sessionStorage.getItem(INVITE_TOKEN_STORAGE_KEY)
    if (!token) {
      navigate('/', { replace: true })
      return
    }

    void (async () => {
      window.sessionStorage.removeItem(INVITE_TOKEN_STORAGE_KEY)
      const { error } = await supabase.rpc('accept_consignee_invite', { p_token: token })
      if (error) {
        // Invite was bad — still send them somewhere reasonable so they
        // aren't stuck. The owner can re-issue if needed.
        console.error('Invite accept failed:', error.message)
        navigate('/', { replace: true })
        return
      }
      navigate('/mom', { replace: true })
    })()
  }, [user, loading, navigate])

  return (
    <div style={{ padding: 'var(--space-8)', textAlign: 'center' }}>
      <p>Completing sign-in…</p>
    </div>
  )
}
